import { toString } from '../util/toString.mjs';

function toUpper(value) {
    return toString(value).toUpperCase();
}

export { toUpper };
